import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
// import { ForgotPasswordService } from '../../../Services/Api/auth';
import { ForgotPasswordService } from '../../../Api/auth';
import { SuccessToast, ErrorToast } from '../../../Utils/SweetAlert';
import { Helmet } from 'react-helmet-async';
import { ForgotPasswordInitialValues, ForgotPasswordValidationSchema } from './constant';
import InputWithLabel from '../../../Components/InputWithLabel';

const ForgotPassword = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>OVE | Admin Forgot Password</title>
      </Helmet>
      <div>
        <div className='main-wrapper login-body'>
          <div className='login-wrapper'>
            <div className='container'>
              <h1 className='img-fluid text-center'>
                {/* <img src='/images/logo.png'  alt='user.png' /> */}
                <div className='forgot-header-logo'>
                <svg
                    width="86px"
                    height="50px"
                    viewBox="0 0 86 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M59.8985 4.5022C58.1023 4.24268 57.9247 4.35876 57.4193 5.78616C54.8604 13.0347 52.2948 20.2764 49.7223 27.5113C49.1896 29.0002 48.5271 29.5602 46.9426 29.5602C44.5591 29.6012 42.1618 29.5943 39.7851 29.5602C38.3782 29.5602 37.6201 28.8772 37.1284 27.5113C34.5331 20.1535 31.931 12.8025 29.3221 5.45835C28.9123 4.29731 28.4821 4.14022 26.6517 4.53634C26.9522 4.9188 27.2254 5.21931 27.4781 5.60177C31.7671 11.3728 31.2617 20.4563 26.2692 25.6263C24.1516 27.7826 21.3992 29.2043 18.4151 29.6831C13.6344 30.5437 9.1473 29.6831 5.20659 26.7122C2.19471 24.4243 0.719508 21.2485 0.214114 17.5878C-0.393726 13.21 0.214114 9.02342 3.05525 5.44468C4.27412 3.80764 5.85259 2.47232 7.66899 1.54162C9.4854 0.610916 11.4912 0.109702 13.5319 0.07658C20.7099 -0.0326944 27.8742 0.172194 35.0795 0.26781C36.6298 0.26781 37.504 1.05322 37.9889 2.65819L41.2262 13.3056C41.4857 14.1662 41.8477 14.9447 42.8312 15.1906C43.1146 15.2778 43.413 15.3055 43.7077 15.272C44.0023 15.2384 44.2868 15.1442 44.5434 14.9954C44.7999 14.8467 45.0229 14.6464 45.1984 14.4073C45.3739 14.1682 45.498 13.8955 45.563 13.6061C46.5533 10.4645 47.4958 7.30919 48.4588 4.16072C48.6364 3.5802 48.8003 2.99967 48.9983 2.42598C49.1473 1.7705 49.5277 1.19072 50.0696 0.793039C50.6116 0.395361 51.2788 0.206453 51.9487 0.260973H52.0648C57.9247 0.179017 63.7914 0.0765817 69.6512 0.0356038C71.4947 -0.0565762 73.3428 0.0303433 75.1696 0.295134C81.4324 1.48349 85.5165 6.83795 85.7487 13.0598C85.7487 13.6608 85.7487 14.2686 85.7487 14.8764C85.7487 16.7409 85.4209 17.0756 83.5837 17.0756H68.2375C67.7802 17.0489 67.3215 17.0787 66.8715 17.1644C66.6892 17.1784 66.5131 17.2371 66.3588 17.3354C66.2045 17.4337 66.0769 17.5684 65.9871 17.7278C65.8973 17.8871 65.8481 18.0661 65.8439 18.249C65.8398 18.4318 65.8807 18.6129 65.9632 18.7762C66.1921 19.6406 66.6635 20.4214 67.3218 21.0265C67.9802 21.6316 68.7979 22.0357 69.6785 22.191C71.666 22.553 73.4895 22.3003 74.9237 20.5929C75.4479 20.0269 76.1581 19.6681 76.9248 19.5821C78.8098 19.4455 80.7084 19.5138 82.6002 19.5411C84.4921 19.5684 85.093 20.5792 84.2462 22.232C83.2221 24.3648 81.6472 26.1855 79.6842 27.5062C77.7212 28.8269 75.4412 29.5996 73.0797 29.7446C69.4395 30.0929 65.8881 29.6353 62.7464 27.4976C61.0358 26.357 59.598 24.853 58.5355 23.0928C57.473 21.3326 56.812 19.3596 56.5997 17.3146C56.2036 14.3883 56.5537 11.4094 57.6174 8.65462C58.0876 7.5854 58.626 6.54745 59.2292 5.54714C59.3999 5.23981 59.6321 4.91881 59.8985 4.5022ZM9.23609 14.9516C9.34516 16.0329 9.53926 17.1039 9.81661 18.1547C10.1415 19.1651 10.7481 20.0618 11.5652 20.7392C12.3823 21.4166 13.3759 21.8466 14.429 21.9786C15.4822 22.1106 16.5511 21.9391 17.5101 21.4843C18.4691 21.0295 19.2783 20.3103 19.8425 19.4113C20.6252 18.1521 21.0658 16.7105 21.1209 15.2289C21.176 13.7473 20.8436 12.2769 20.1567 10.9631C19.7466 10.1306 19.1356 9.41343 18.3789 8.87628C17.6222 8.33914 16.7436 7.99895 15.8225 7.88643C14.9014 7.77392 13.9668 7.89262 13.103 8.23184C12.2393 8.57104 11.4736 9.12007 10.8752 9.82933C9.72233 11.2796 9.13938 13.1014 9.23609 14.9516ZM71.2425 12.5134C72.6767 12.5134 74.111 12.5134 75.5384 12.5134C76.3511 12.5134 76.6789 12.1582 76.4877 11.284C75.9277 8.73658 74.0154 7.22722 71.2357 7.22039C70.0538 7.15369 68.8873 7.51443 67.9493 8.23669C67.0114 8.95895 66.3646 9.99454 66.1271 11.1543C65.9017 12.0763 66.1954 12.5202 67.1652 12.5202C68.5107 12.5066 69.8766 12.5134 71.2425 12.5134Z"
                      fill="#AD5ADC"
                    />
                  </svg>
                </div>
              </h1>
              <div className='loginbox'>
                <div className='login-right'>
                  <div className='login-right-wrap'>
                    <h1 className='forgot-title'>Forgot Password</h1>
                    <p className='forgot-subtitle'>Enter your email to get a password reset link</p>
                    <Formik
                      initialValues={ForgotPasswordInitialValues}
                      validationSchema={ForgotPasswordValidationSchema}
                      validateOnChange
                      onSubmit={async (values, { setSubmitting, resetForm }) => {
                        await ForgotPasswordService({ ...values })
                          .then((res) => {
                            SuccessToast(res?.data?.message);
                            setSubmitting(false);
                            resetForm();
                            navigate('/');
                          })
                          .catch((err) => {
                            if (typeof err.response.data.message !== 'undefined') {
                              ErrorToast(err.response.data.message || 'Server Error!!');
                            } else {
                              ErrorToast(err?.message || 'Server Error!!');
                            }
                            setSubmitting(false);
                          });
                      }}
                    >
                      {({ handleSubmit, isSubmitting }) => {
                        return (
                          <Form onSubmit={handleSubmit}>
                            <Field
                              Label='Email'
                              type='email'
                              name='email'
                              placeholder='Enter Email'
                              component={InputWithLabel}
                            />
                            <div className='form-group mb-0'>
                              <button
                                className='forgot-submit-btn btn btn-lg btn-block w-100'
                                disabled={isSubmitting}
                                type='submit'
                              >
                                Reset Password&nbsp;&nbsp;
                                {isSubmitting && <i className='fas fa-spinner fa-spin'></i>}
                              </button>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                    <div className='text-center remember-text-class-link mt-4'>
                      Remember your password?{' '}
                      <NavLink to='/' className=''>
                        Login
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;